<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="deposit-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getDepositAuditList()"
          @handleCurrentChange="() => getDepositAuditList()"
          :cellStyle="cellStyle"
          :cellClick="cellClick"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractType'">
                {{ getColumnName('contractType', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'applicationType'">
                {{ getColumnName('applicationType', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'auditStatus'">
                {{ getColumnName('auditStatus', scope.row[item.field]) }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns, defaultTableColumns } from './columns';
  import DepositCommonMixin from '@/pages/property/deposit/mixins/DepositCommonMixin';
  export default {
    name: 'DepositAudit',
    mixins: [DepositCommonMixin],
    components: {
      SiruiSearch,
    },
    mounted() {
      this.queryData.depositCompanyNo = this.userInfo.companyCode;
      // this.queryData.depositDepartmentNo = this.userInfo.departmentCode;
      this.$refs.siruiTable.setPageSize(10);
      this.getDepositAuditList();
      this.getButtonList();
      this.getDepartmentList(this.userInfo.companyCode);
    },
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    methods: {
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData = {
          depositCompanyNo: this.userInfo.companyCode,
        };
        this.getDepositAuditList();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getDepositAuditList();
      },
      // selectProjectHandler(row) {
      //   //项目转合同
      //   let params = { projectCode: row.projectCode, pageMode: 0, origin: 'createFrom' };
      //   this.toDetailPage(params);
      // },

      // 表格上面的按钮
      async chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        let item = this.selectedItems[0];

        console.log('listStatus', empty, justOne);
        console.log('click', type);

        if (empty) {
          this.$message.error('请选择数据！');
          return;
        }
        if (!justOne && type != 'export') {
          this.$message.error('请选择一条数据！');
          return;
        }

        if (item.auditStatus != '01' && type != 'export') {
          this.$message.error('请选择一条待审核的数据！');
          return;
        }

        switch (type) {
          case 'audit':
            this.toDepositAuditDetail(item.id, true);
            break;
          case 'export':
            this.handleExport(this.selectedItems, true);
            break;
          default:
            break;
        }
      },
      cellClick(val) {
        if (val.column?.property == 'applicationNo') {
          this.toDepositAuditDetail(val.row.id);
        } else if (val.column?.property == 'contractNo') {
          console.log('clickContract', val);
          this.toLeaseContractDetail(val.row.contractId);
        }
      },
      cellStyle({ column }) {
        if (column.property == 'applicationNo' || column.property == 'contractNo') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
          };
        }
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns(this.isCustomerContract)).then(() => {
          this.tableColumns = defaultTableColumns(this.isCustomerContract);
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
